/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// material
import { SubPage, Copy, Title, CTAs, Button, Form, Grid, GridSet, GridItem, TextField, SelectField, SaveButton, TextAreaField } from '@insticator/insticator-ui'; // iui-material
import LabelAssignmentField from 'material/embeds/labelassignmentfield/labelassignmentfield_container'
import CreateEmbedButton from 'material/ctas/createembed/createembed';
// utils
import { isFormValid } from '@insticator/insticator-ui'; // iui-utils
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/embeds/management/editembedname/editembedname_styles';



/* ========== ~~~~~~~~~~ EMBED EDIT NAME ~~~~~~~~~~ ========== */
class EditEmbedName extends Component {
    constructor(props){
        super(props);
        this.formName = 'editembedname';
        this.disableSaveButton = false;
    }
    componentDidMount() {
        // Populates form data with the data from session status.
        // The data will be stored in session status if user logs in by clicking on log in button
        // In that case session status is pupulated with the auth data before the component mounts
        const { embedName, siteUUID } = this.props;
        if (!this.props.createEmbed) this.props.receiveFormData(this.formName, { embedName, siteUUID });
        if (this.props.mockupGenerator && !!this.props.mockedSiteUUID) this.props.receiveFormData(this.formName, { siteUUID: this.props.mockedSiteUUID })

    }
    componentDidUpdate(prevProps) {
        // if (prevProps.userEmail !== this.props.userEmail) this.props.receiveFormData(this.formName, this.getFormCallData(false))

        // To update the name of the existing embed we need to call updateEmbed method which is defined in a separate component
        // This method accepts embed related slices of state, transpiles them and makes the call to the BE
        // Ensure embed's name is updated in store and make a call to save embed's data
        if(!this.props.isNewEmbedFlow && prevProps.embedName !== this.props.embedName) {
            this.disableSaveButton = true;
            this.props.updateEmbed()
        }
        // Once update call is processed, close the modal.
        if(!this.props.isNewEmbedFlow && prevProps.isSavingData && !this.props.isSavingData) this.props.displayModal(false);

    }
    handleKeyPress = e => {
        if(e.keyCode === 13){
            this.actionOnSubmit()
        }
    };
    actionOnSubmit = () => {
        isFormValid(this.props.fields) && this.isNewName() ? this.processEmbed() : this.props.invalidateForm(this.formName);
    };
    processEmbed = () => {
        // This method will update embed name in the selectedEmbedStatus slice of state.
        // For both new and existing embeds we need to update the name of the embed in the selectedEmbedStatus slice of state
        // New embed then will be created by calling the appropriate method at the end of the embed creation workflow.
        // For the existing embed we make an update call in the componentDidUpdate (see above)
        const embedData = {
            siteUUID: this.props.fields.website.value,
            siteURL: this.props.sites[this.props.fields.website.value],
            embedName: this.props.fields.embedname.value,
            attachedLabelUUIDs: this.props.attachedLabelUUIDs
        };
        // Update/Set embed's name in the appropriate slice of state.
        // Navigate to the embed workflow if the modal is invoked from the library or the code pages
        this.props.createEmbed ? this.props.moveToEmbedCreationWithStateReset(embedData) : this.props.setEmbedProperties(embedData);
        if(this.props.isNewEmbedFlow) this.props.displayModal(false);
    };
    isNewName = () => {
        const embedName = this.props.fields.embedname.value;
        return this.props.embedNames.includes(embedName) ? this.handleDuplecativeName() : true;
    };
    handleDuplecativeName = () => {
        this.props.setFieldValidation(this.formName, 'embedname', false);
        this.props.sendMessage(`Embeds on the same site cannot share the same name`);
        return false;
    };
    componentWillUnmount() {
        this.props.resetForm(this.formName)
    }
    _getSiteOptions = () => {
        return Object.entries(this.props.sites).map(([siteUUID, siteURL]) => ({ name: siteUUID, value: siteUUID, text: siteURL }));
    };
    render() {
        const { embedname, website } = this.props.fields;
        const isEditable = this.props.createEmbed || !this.props.embedUUID;
        const nameChanged = this.props.embedName !== this.props.fields.embedname.value;
        return(
            <SubPage name={`editembedname`} klass={this.props.classes.editembedname}>
                <Form name={this.formName} processing={this.props.savingData}>
                    <Copy name={`title`}>
                        <Title size={`medium`}>
                            <h2>{!!this.props.createEmbed ? `New Embed` : `Edit Embed Details`}</h2>
                        </Title>
                    </Copy>
                    <Grid direction={`vertical`} type={`fields`}>
                        <GridSet direction={`vertical`}>
                            <GridItem>
                                <TextField formName={this.formName}
                                       type={`text`}
                                       name={`embedname`}
                                       value={embedname.value}
                                       valid={embedname.valid}
                                       placeholder={``}
                                       disabled={this.props.isSavingData}
                                       label={`What is your embed's name?`}
                                       info={``}
                                       onKeyDown={this.handleKeyPress}
                                       required />
                            </GridItem>
                            <GridItem>
                                <SelectField formName={this.formName}
                                       type={`select`}
                                       name={`website`}
                                       placeholder={``}
                                       label={`Where will your embed live?`}
                                       dummyOptionText={`Select your website`}
                                       info={``}
                                       disabled={!isEditable || this.props.mockupGenerator}
                                       value={ this.props.createEmbed || this.props.isNewEmbedFlow ? website.value : this.props.siteUUID }
                                       valid={website.valid}
                                       options={this._getSiteOptions()}
                                       required />
                            </GridItem>
                            {this.props.createEmbed && <GridItem>
                                <LabelAssignmentField attachedLabelUUIDs={this.props.attachedLabelUUIDs}
                                                      attachLabel={this.props.attachLabel}
                                                      removeLabel={this.props.removeLabel}
                                />
                            </GridItem>}
                        </GridSet>
                    </Grid>
                    <CTAs name={`ctas`}>
                        {!this.props.createEmbed && <Button type={`modal`} action={false} variant={`delete`} name={`cancel`} text={`Cancel`} />}
                        {!this.props.createEmbed ? <SaveButton savingData={this.props.savingData || this.props.isSavingData}
                                                               handleSave={this.actionOnSubmit}
                                                               buttonText={!this.props.isNewEmbedFlow && nameChanged ? null : 'Saved'}
                                                               disabled={(!this.props.isNewEmbedFlow && !nameChanged) || this.props.isSavingData || this.disableSaveButton}
                                                    /> :
                            <CreateEmbedButton creatingEmbed={this.props.savingData} handleCreateEmbed={this.actionOnSubmit} />}
                    </CTAs>
                </Form>
            </SubPage>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(EditEmbedName);
